import { call, put, takeEvery } from 'redux-saga/effects';

import { insightsApi } from 'config/axios';
import {
    FETCH_INSIGHTS_LIST,
    FETCH_INSIGHTS_LIST_FETCHING,
    FETCH_INSIGHTS_LIST_SUCCESS,
    FETCH_INSIGHTS_LIST_FAIL,
    FETCH_INSIGHT_DATA,
    FETCH_INSIGHT_DATA_FETCHING,
    FETCH_INSIGHT_DATA_SUCCESS,
    FETCH_INSIGHT_DATA_FAIL,
    UPDATE_INSIGHT_STATUS,
    UPDATE_INSIGHT_STATUS_UPDATING,
    UPDATE_INSIGHT_STATUS_SUCCESS,
    UPDATE_INSIGHT_STATUS_FAIL
} from '../actions/ActionTypes';

// Workers
export function* fetchInsightsListSaga() {
    try {
        yield put({
            type: FETCH_INSIGHTS_LIST_FETCHING
        });

        const response = yield call(insightsApi.get, `/gcs-insights/api/feature/history`);

        yield put({
            type: FETCH_INSIGHTS_LIST_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_INSIGHTS_LIST_FAIL,
            data: []
        });
    }
}

export function* fetchInsightDataSaga(action) {
    const { featureId, createdDateUTC, lang } = action;

    try {
        yield put({
            type: FETCH_INSIGHT_DATA_FETCHING,
            createdDateUTC: createdDateUTC,
            data: {}
        });

        const response = yield call(
            insightsApi.get,
            `/gcs-insights/api/feature/details/?featureId=${featureId}&date=${createdDateUTC}&lang=${lang}`,
            {
                // CHART_VER must be explicitly set to fetch the correct chart data
                headers: {
                    CHART_VER: 4.0
                }
            }
        );

        yield put({
            type: FETCH_INSIGHT_DATA_SUCCESS,
            createdDateUTC: createdDateUTC,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_INSIGHT_DATA_FAIL,
            createdDateUTC: createdDateUTC,
            data: {}
        });
    }
}

// This endpoint requires a 'date' key be added on to the payload that's returned even though the createDateUTC, which came from the GET request, is the same value
// Documentation is here but not much good since it currently doesn't match what's actually needed: https://insights.gcs.garmin.com/gcs-insights/swagger-ui/#/insights-feature-controller/updateStatus
// Status can be set to UNREAD, DELETED, READ, FAVORITED, DISMISSED
export function* updateInsightStatusSaga(action) {
    const { newStatus, createdDateUTC, featureId, flagId } = action;

    try {
        yield put({
            type: UPDATE_INSIGHT_STATUS_UPDATING,
            createdDateUTC: createdDateUTC,
            flagId: flagId
        });

        yield call(insightsApi.post, `/gcs-insights/api/feature/status/${newStatus}`, {
            date: createdDateUTC,
            featureId: featureId
        });

        yield put({
            type: UPDATE_INSIGHT_STATUS_SUCCESS,
            createdDateUTC: createdDateUTC,
            flagId: flagId
        });
    } catch (e) {
        yield put({
            type: UPDATE_INSIGHT_STATUS_FAIL,
            createdDateUTC: createdDateUTC,
            flagId: flagId
        });
    }
}

// Watchers
export const insightsSagas = [
    takeEvery(FETCH_INSIGHTS_LIST, fetchInsightsListSaga),
    takeEvery(FETCH_INSIGHT_DATA, fetchInsightDataSaga),
    takeEvery(UPDATE_INSIGHT_STATUS, updateInsightStatusSaga)
];
